// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5203":"dbf42ffdd130568f","6218":"ae958cc637ae36e0"}[chunkId] + ".js";
};